<template>
  <div class="chat-box__header">
    <button v-if="showBackButton" class="chat-box__header-button" @click="back">
      <arrow-left-icon class="chat-box__header-back-icon" />
    </button>
    <span class="chat-box__header-title">
      {{ title }}
    </span>
    <div class="chat-box__header__icons">
      <button
        v-show="activeChat"
        class="chat-box__header-button"
        @click="minimize"
      >
        <window-minimize-icon class="chat-box__header-minimize-icon" />
      </button>
      <button class="chat-box__header-button" @click="close">
        <close-circle-icon class="chat-box__header-delete-icon" />
      </button>
    </div>
    <hcc-confirmation />
  </div>
</template>

<script>
import CloseCircleIcon from '@/assets/icons/close-circle.svg';
import ArrowLeftIcon from '@/assets/icons/arrow-left.svg';
import WindowMinimizeIcon from '@/assets/icons/window-minimize.svg';
import HccConfirmation from '@/components/shared/HccConfirmation/index.vue';

export default {
  components: {
    CloseCircleIcon,
    ArrowLeftIcon,
    WindowMinimizeIcon,
    HccConfirmation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    activeChat: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      if (!this.activeChat) {
        this.$emit('close');
      } else {
        this.$modal.show('confirmation', {
          title: this.$t('chat-button.close'),
          description: this.$t('chat-button.confirm-close'),
          confirm: () => this.$emit('close'),
        });
      }
    },
    back() {
      this.$emit('go-back');
    },
    minimize() {
      this.$emit('minimize');
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/components/chatButton/_chat-button.scss";
</style>
